var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUser = function SvgUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "usuario",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.95 16.56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a9a9a9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_5436"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.23,16.41c-.31,0-.56-.25-.56-.56v-2.13c0-2.04-1.26-3.7-2.81-3.7h-6.75c-1.55,0-2.81,1.66-2.81,3.7v2.13c0,.31-.25.56-.56.56s-.56-.25-.56-.56v-2.13c0-2.66,1.77-4.83,3.94-4.83h6.75c2.17,0,3.94,2.17,3.94,4.83v2.13c0,.31-.25.56-.56.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_5437"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.48,7.91c-2.14,0-3.88-1.74-3.88-3.88S5.34.16,7.48.16c2.14,0,3.88,1.74,3.88,3.88s-1.74,3.88-3.88,3.88Zm0-6.75c-1.59,0-2.88,1.29-2.88,2.88s1.29,2.88,2.88,2.88,2.88-1.29,2.88-2.88-1.29-2.88-2.88-2.88Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "user.36d8fcc9286711b6f4f763f9eb1c6220.svg";